import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { ALERT_CONFIRM_CHECKED } from '@/api/notification/alertServerValues.ts'
import { EmergencyAlertConfirmStatus } from '@/api/notification/getNotificationSos.ts'
import { getAlertConfirmName } from '@/util/alertDisplay.ts'

export interface IProps {
    value?: string
    className?: string
}

const AlertConfirmStatusBadge: React.FC<IProps> = ({ className, value }) => {
    const { t } = useTranslation()

    const typeClassName = useMemo(() => {
        switch (value) {
            case EmergencyAlertConfirmStatus.WAIT:
            case EmergencyAlertConfirmStatus.ASSIGN:
                return 'border-sub_r text-sub_r'
            case ALERT_CONFIRM_CHECKED:
                return 'border-main_b text-main_b'
            default:
                return 'border-gray3 text-gray3'
        }
    }, [value])

    const typeName = useMemo(() => getAlertConfirmName(t, value), [value, t])


    return <div
        className={`${className} border border-solid inline-block rounded-[5px] px-[2px] py-[3px] text-[10px] whitespace-nowrap ${typeClassName}`}>
        {typeName}
    </div>
}

export default AlertConfirmStatusBadge